import { PaymentOptionPropertiesInterface } from '../../../services/exports/Interfaces';
import { PaymentMethod, PaymentMethodBrand } from '../../../services/exports/Constants';
import VisaIcon from '../../../assets/icons/payment-methods/VisaIcon';
import MasterCardIcon from '../../../assets/icons/payment-methods/MasterCardIcon';
import CashIcon from '../../../assets/icons/payment-methods/CashIcon';
import ApplePayIcon from '../../../assets/icons/payment-methods/ApplePayIcon';
import GooglePayIcon from '../../../assets/icons/payment-methods/GooglePayIcon';
import PayPalIcon from '../../../assets/icons/payment-methods/PayPalIcon';
import KlarnaIcon from '../../../assets/icons/payment-methods/KlarnaIcon';
import GiroPayIcon from '../../../assets/icons/payment-methods/GiroPayIcon';
import SepaDebitIcon from '../../../assets/icons/payment-methods/SepaDebitIcon';
import AmericanExpressIcon from '../../../assets/icons/payment-methods/AmericanExpressIcon';
import { ReactElement } from 'react';

interface Props extends Partial<PaymentOptionPropertiesInterface> {
  className?: string;
}

export const getBrandIcon = (brand: PaymentMethodBrand): ReactElement =>
  ({
    [PaymentMethodBrand.Visa]: <VisaIcon />,
    [PaymentMethodBrand.MasterCard]: <MasterCardIcon />,
    [PaymentMethodBrand.AmericanExpress]: <AmericanExpressIcon />,
  })[brand] ?? null;

export default function PaymentMethodBrandIcons(props: Props) {
  const { payment_method_id, payment_method_brand, className } = props;

  const paymentMethodIcon =
    {
      [PaymentMethod.Cash]: <CashIcon className={className} />,
      [PaymentMethod.ApplePay]: <ApplePayIcon className={className} />,
      [PaymentMethod.GooglePay]: <GooglePayIcon className={className} />,
      [PaymentMethod.Card]: (
        <div className="flex gap-2">
          <VisaIcon className={className} />
          <MasterCardIcon className={className} />
          <AmericanExpressIcon className={className} />
        </div>
      ),
      [PaymentMethod.Paypal]: <PayPalIcon className={className} />,
      [PaymentMethod.Sofort]: <KlarnaIcon className={className} />,
      [PaymentMethod.Giropay]: <GiroPayIcon className={className} />,
      [PaymentMethod.SepaDebit]: <SepaDebitIcon className={className} />,
    }[payment_method_id] ?? null;

  return getBrandIcon(payment_method_brand) ?? paymentMethodIcon;
}
